import React from 'react';
import {Card, Col, Layout, Row, Button, Typography} from "antd";
import logo from "../../resources/img/logo.png";
import {ArrowLeftOutlined, LogoutOutlined} from "@ant-design/icons";

import {withRouter} from "react-router";
import {connect} from "react-redux";
import showLogin from "../../actions/showLogin";
import {REPORT_LIST_ROUTE} from "../Root/routes";
import {Link} from "react-router-dom";

const MainLayout = (props) => {
    const isDashboard = props.variant === 'dashboard';
    const isReport = props.variant === 'report';
    const userName = props.login.profileObj && (props.login.profileObj.name || props.login.profileObj.email);

    const handleLogout = () => {
        // 1. Limpia sesión local
        localStorage.clear();

        // 2. Limpia Redux y redirige a la ruta base de Login
        props.showLogin(false);
    };

    const renderImg = () => {
        return (
            <span className="layout-logo-frame">
                <img alt="Orange Digital" src={logo}/>
            </span>
        );
    };

    const getSize = (size) => {
        switch (size) {
            case 'sm':
                return props.size === 'large' ? 18 : 14;
            case 'md':
                return props.size === 'large' ? 16 : 10;
            case 'xl':
                return props.size === 'large' ? 14 : 8;
            default:
                break;
        }
    };

    if (isDashboard || isReport) {
        return (
            <Layout className="h-100 public-layout commercial-layout">
                <Layout.Header className="commercial-header">
                    <div className="commercial-header-inner">
                        <div className="commercial-header-brand">
                            <span className="commercial-logo-frame">
                                <img alt="Orange Digital" src={logo}/>
                            </span>
                            <div className="commercial-header-copy">
                                <Typography.Title level={1}>Reportes Comerciales</Typography.Title>
                                <Typography.Text>
                                    Consulta y exporta información de consumo para auditoría y facturación.
                                </Typography.Text>
                            </div>
                        </div>
                        {props.login.tokenId && props.login.profileObj ?
                            <div className="commercial-header-actions">
                                {userName ? <Typography.Text className="commercial-user">{userName}</Typography.Text> : ''}
                                <Button danger icon={<LogoutOutlined/>} onClick={handleLogout}>
                                    Cerrar sesión
                                </Button>
                            </div> : ''}
                    </div>
                </Layout.Header>
                <Layout.Content className={isReport ? 'commercial-content report-content' : 'commercial-content'}>
                    {isReport ?
                        <div className="report-screen">
                            <div className="report-screen-intro">
                                <div className="report-screen-heading">
                                    <div className="report-screen-heading-copy">
                                        <Typography.Title level={2}>{props.reportTitle}</Typography.Title>
                                        {props.reportDescription ? <Typography.Text>{props.reportDescription}</Typography.Text> : ''}
                                    </div>
                                    {props.login.tokenId && props.login.profileObj ?
                                        <Link className="report-back-link" to={REPORT_LIST_ROUTE}>
                                            <ArrowLeftOutlined/>
                                            <span>Volver al menú principal</span>
                                        </Link> : ''}
                                </div>
                            </div>
                            {props.children}
                        </div> :
                        props.children}
                </Layout.Content>
            </Layout>
        );
    }

    return (
        <Layout className="h-100 public-layout public-auth-layout">
            <Layout.Content className="public-auth-content">
                <Row justify="space-around" align="middle" className={'h-100 public-auth-row'}>
                    <Col xs={24} sm={getSize('sm')} md={getSize('md')} xl={getSize('xl')} className="public-auth-col">
                        <Card bodyStyle={props.bodyStyle?props.bodyStyle:{}} className={'public-card'} title={props.title === 'logo' ? renderImg() : props.title}
                              headStyle={{textAlign: 'center'}}>
                            <Row justify={'center'} className={'w-100'}>
                                {props.children}
                            </Row>
                            {props.login.tokenId && props.login.profileObj?
                                <>
                                    <Row justify={'center'} className={'w-100 public-card-nav'}>
                                        <Link to={REPORT_LIST_ROUTE}>Volver al Menú Principal</Link>
                                    </Row>
                                    <Row justify={'center'} className={'w-100'}>

                                    <Button danger onClick={handleLogout}>
                                        Cerrar sesión
                                    </Button>
                                </Row></>:''}
                        </Card>
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    );
};
function mapStateToProps(state) {
    return {
        login: state.login
    }
}
export default withRouter(connect(mapStateToProps, {showLogin})(MainLayout));
